module.exports = __webpack_public_path__ + "img/healthCheck.ef47f091.svg";